<template>
  <div style="margin-top: -20px !important">
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <template v-else>
      <!--  Customer header -->
      <b-row
        class="hidden-sm-down d-print-none px-pad py-2 border-bottom justify-content-center align-items-center"
        style="height: 65px"
      >
        <b-col cols="6" class="text-left px-0">
          <div class="d-flex w-100">
            <span>
              <i class="la la-user img-circle"></i>
            </span>
            <div class="mx-2 mt-2 w-75 text-truncate">
              <h5 class="mb-1 text-truncate w-100">
                {{ list.main_detail.cus_display_name }}
              </h5>
              <small class="text-muted fw-semi-bold mb-2">
                <i class="fa fa-phone mr-1"></i>
                {{
                  list.main_detail.cus_ph_no_1 ||
                  list.main_detail.cus_ph_no_2 ||
                  ""
                }}
              </small>
              |
              <small
                class="text-muted fw-semi-bold mb-2"
                v-b-tooltip.title="'Customer ID'"
                v-if="list.main_detail.cus_legacy_id"
              >
                <i class="la la-bookmark la-lg mr-1"></i>
                {{ list.main_detail.cus_legacy_id }}
              </small>
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="text-right px-0">
          <b-dropdown
            v-if="
              list.main_detail.cus_status == 1 &&
              (RoutePermission(true, 'AmcContractCreate', '', '', '') ||
                RoutePermission(false, '', '', 'invoice', 'create') ||
                RoutePermission(false, '', '', 'paymentsreceived', 'create') ||
                RoutePermission(true, 'RetainerInvoiceCreate', '', '', '') ||
                RoutePermission(false, '', 'invoice', 'quotation', 'create') ||
                RoutePermission(
                  false,
                  '',
                  'invoice',
                  'recurringinvoice',
                  'create'
                ))
            "
            right
            variant="primary"
            size="sm"
            class="mr-2"
            text="Transactions"
            v-b-tooltip.title="'New Transactions'"
            style="height: 31px !important"
          >
            <b-dropdown-item
              v-if="RoutePermission(true, 'AmcContractCreate', '', '', '')"
              @click="
                goTransaction(
                  'AmcContractCreate',
                  'AmcContract',
                  list.main_detail.cus_id
                )
              "
              >AMC Contract</b-dropdown-item
            >
            <b-dropdown-item
              v-if="RoutePermission(false, '', '', 'invoice', 'create')"
              @click="
                goTransaction(
                  'InvoiceCreate',
                  'Invoice',
                  list.main_detail.cus_id
                )
              "
              >Invoice</b-dropdown-item
            >
            <b-dropdown-item
              v-if="
                RoutePermission(false, '', '', 'paymentsreceived', 'create')
              "
              @click="
                goTransaction(
                  'PaymentCreate',
                  'Payment',
                  list.main_detail.cus_id
                )
              "
              >Customer Payment</b-dropdown-item
            >
            <b-dropdown-item
              v-if="RoutePermission(true, 'RetainerInvoiceCreate', '', '', '')"
              @click="
                goTransaction(
                  'RetainerInvoiceCreate',
                  'RetainerInvoice',
                  list.main_detail.cus_id
                )
              "
              >Customer Deposit</b-dropdown-item
            >
            <b-dropdown-item
              v-if="
                RoutePermission(false, '', 'invoice', 'quotation', 'create')
              "
              @click="
                goTransaction('SalesCreate', 'Sales', list.main_detail.cus_id)
              "
              >Quotation</b-dropdown-item
            >
            <b-dropdown-item
              v-if="
                RoutePermission(
                  false,
                  '',
                  'invoice',
                  'recurringinvoice',
                  'create'
                )
              "
              @click="
                goTransaction(
                  'RecurringInvoiceCreate',
                  'RecurringInvoice',
                  list.main_detail.cus_id
                )
              "
              >Recurring Invoice</b-dropdown-item
            >
          </b-dropdown>
           <b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if="RoutePermission(false, '', '', 'customer', 'create')"
        :to="{ name: 'CustomerCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New Customer
        </b-button>

          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="
                list.main_detail.cus_status == 1 &&
                RoutePermission(false, '', 'invoice', 'customer', 'update')
              "
              :to="{
                name: 'CustomerUpdate',
                params: { id: $route.params.id },
                query: { page_from: 'view' },
              }"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>
            <b-dropdown
              right
              variant="light"
              no-caret
              size="sm"
              style="height: 33px !important"
              v-if="
                RoutePermission(false, '', '', 'customer', 'update') ||
                RoutePermission(false, '', '', 'customer', 'create') ||
                RoutePermission(false, '', 'invoice', 'settings', 'templates')
              "
            >
              <template slot="button-content">
                <i
                  class="glyphicon glyphicon-option-vertical"
                  style="padding-bottom: 3px"
                ></i>
              </template>
              <b-dropdown-item
                v-if="
                  list.main_detail.cus_status == 1 &&
                  RoutePermission(false, '', '', 'customer', 'create')
                "
                :to="{
                  name: 'CustomerCreate',
                  query: {
                    clone_id: $route.params.id,
                    page_from: 'view',
                  },
                }"
              >
                <i class="la la-clone la-lg mr-3"></i>Clone
              </b-dropdown-item>
              <b-dropdown-item
                @click="showFullLayout"
                v-if="
                  RoutePermission(false, '', 'invoice', 'settings', 'templates')
                "
              >
                <i class="la la-cog la-lg mr-3"></i>Customize Print
              </b-dropdown-item>
              <b-dropdown-item
                v-if="RoutePermission(false, '', '', 'customer', 'update')"
                @click="
                  statusPage =
                    list.main_detail.cus_status == 1 ? 'inactive' : 'active'
                "
                v-b-modal.statusPage
              >
                <i
                  :class="
                    list.main_detail.cus_status == 1 ? 'la-ban' : ' la-check'
                  "
                  class="la la-lg mr-3"
                ></i>
                Mark as
                {{ list.main_detail.cus_status == 1 ? "inactive" : "active" }}
              </b-dropdown-item>
            </b-dropdown>
            <b-button
              variant="light"
              size="sm"
              title="delete"
              v-if="
                list.main_detail.is_used == 0 &&
                RoutePermission(false, '', 'invoice', 'customer', 'delete')
              "
              @click="
                handlingapprovingmodal({
                  content: 'Are you sure you want to delete this customer ?',
                  title:
                    'Delete Customer - ' + list.main_detail.cus_display_name,
                  module: 'customer/deletecustomer',
                  data: JSON.stringify({
                    id: $route.params.id,
                  }),
                  RoutePlace: 'Customer',
                  isRoute: 'true',
                  type: 'delete',
                  route_history: cus_index_history,
                })
              "
            >
              <i class="glyphicon glyphicon-trash"></i>
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="cus_index_history ? cus_index_history : { name: 'Customer' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <div class="d-flex" style="margin-left: -20px; margin-right: -20px">
        <div class="view-content-block border-left d-none d-lg-block">
          <div class="py-3">
            <h6
              class="fw-semi-bold theme-text-color px-pad"
              style="padding-bottom: 6px"
            >
              Customer Details
            </h6>
            <div class="border-bottom"></div>
            <b-row class="px-pad pt-2 pb-1">
              <b-col cols="12" class="text-truncate">{{
                list.main_detail.cus_display_name
              }}</b-col>
            </b-row>
            <b-row class="px-pad pb-1">
              <b-col cols="12">
                <small class="text-muted">
                  <span style="width: 23px !important">
                    <i class="fa fa-phone mr-2"></i>
                  </span>
                  {{
                    list.main_detail.cus_ph_no_1 ||
                    list.main_detail.cus_ph_no_2 ||
                    ""
                  }}
                </small>
              </b-col>
            </b-row>
            <b-row class="px-pad pb-1" v-if="list.main_detail.cus_mail">
              <b-col cols="12" class="text-truncate">
                <small class="text-muted">
                  <span style="width: 23px !important">
                    <i class="la la-envelope-o la-lg mr-2"></i>
                  </span>
                  {{ list.main_detail.cus_mail }}
                </small>
              </b-col>
            </b-row>

            <div class="border-bottom"></div>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
              v-b-toggle.contact-details
            >
              Contact Persons ({{ list.cus_cntct.length }})
            </h6>
            <div class="border-bottom"></div>
            <b-collapse id="contact-details" visible>
              <div class="w-100 px-pad">
                <div
                  v-for="(item, index) in list.cus_cntct"
                  :key="index"
                  class="py-2 d-flex"
                >
                  <div>
                    <i class="la la-user la-lg mr-2 text-muted"></i>
                  </div>
                  <div class="w-100 px-pad">
                    <div class="cus-view-addr">
                      {{ item.cntct_fname + " " + item.cntct_lname }}
                    </div>
                    <div class="cus-view-addr">{{ item.cntct_no }}</div>
                    <div class="cus-view-addr">{{ item.cntct_mail }}</div>
                  </div>
                </div>
              </div>
            </b-collapse>
            
            <template
              v-if="
                reporting_tags.filter(
                  (tag) =>
                    list.main_detail[tag.tag_column_name] != '' &&
                    list.main_detail[tag.tag_column_name] != null
                ).length != 0
              "
            >
              <div class="border-bottom"></div>
              <h6
                class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                style="padding-bottom: 6px"
                v-b-toggle.reporting-details
              >
                Reporting Tags
              </h6>
              <div class="border-bottom"></div>
              <b-collapse id="reporting-details" visible>
                <div class="w-100 px-pad">
                  <div
                    v-for="(tag, index) in reporting_tags"
                    :key="index"
                    v-if="
                      list.main_detail[tag.tag_column_name] != '' &&
                      list.main_detail[tag.tag_column_name] != null &&
                      list.main_detail[tag.tag_column_name] != 0
                    "
                    class="py-2 d-flex w-100"
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      {{ tag.tag_name }}
                    </div>
                    <div class="cus-view-addr w-50">
                      {{
                        getJsonPresentValue(
                          tag.tag_options,
                          "value",
                          list.main_detail[tag.tag_column_name],
                          "label"
                        )
                      }}
                    </div>
                  </div>
                </div>
              </b-collapse>
            </template>

            <template
              v-if="
                cus_settings_details.custom_field.filter(
                  (custom_field) =>
                    list.main_detail[custom_field.field_name] &&
                    custom_field.status == 1 &&
                    custom_field.permissions != 'hide'
                ).length != 0
              "
            >
              <div class="border-bottom"></div>
              <h6
                class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                style="padding-bottom: 6px"
                v-b-toggle.custom-details
              >
                Custom Fields
              </h6>
              <div class="border-bottom"></div>
              <b-collapse id="custom-details">
                <div class="w-100 px-pad">
                  <div
                    v-for="custom_field in cus_settings_details.custom_field"
                    :key="custom_field.id"
                    v-if="
                      list.main_detail[custom_field.field_name] &&
                      custom_field.status == 1 &&
                      custom_field.permissions != 'hide'
                    "
                    class="py-2 d-flex w-100"
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      {{ custom_field.label_name }}
                    </div>
                    <div
                      v-if="custom_field.datatype == 'select'"
                      class="cus-view-addr w-50"
                    >
                      {{
                        getJsonPresentValue(
                          custom_field.options,
                          "value",
                          list.main_detail[custom_field.field_name],
                          "label"
                        )
                      }}
                    </div>
                    <div
                      v-else-if="custom_field.datatype == 'date'"
                      class="cus-view-addr w-50"
                    >
                      {{
                        getDateFormat(list.main_detail[custom_field.field_name])
                      }}
                    </div>
                    <div
                      v-else-if="custom_field.datatype == 'amount'"
                      class="cus-view-addr w-50"
                    >
                      {{
                        orgCurrencySymbol +
                        " " +
                        list.main_detail[custom_field.field_name]
                      }}
                    </div>
                    <div
                      v-else-if="custom_field.datatype == 'checkbox'"
                      class="cus-view-addr w-50"
                    >
                      {{
                        list.main_detail[custom_field.field_name] == 1
                          ? "True"
                          : "False"
                      }}
                    </div>
                    <div v-else class="cus-view-addr w-50">
                      {{ list.main_detail[custom_field.field_name] }}
                    </div>
                  </div>
                </div>
              </b-collapse>
            </template>
            <b-tabs class="customer_view_tab custom-tab" card>
              <b-tab
                title="Details"
                active
                class="px-pad py-2"
                title-link-class="text-center"
              >
                <div class="w-100" >
                  <div class="d-flex w-100 py-2" >
                  <div class="cus-view-addr w-50 text-muted">Customer ID</div>
                  <div class=" w-50">{{ list.main_detail.cus_legacy_id||'-' }}</div>
                </div>
                  <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Customer Type</div>
                  <div class=" w-50">{{ list.main_detail.cus_type==1?'Person':'Organization' }}</div>
                </div>
                  <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Payment Terms</div>
                  <div class=" w-50">{{ list.main_detail.term_name }}</div>
                </div>
                  <div
                    v-if="
                      list.main_detail.cus_proof_id &&
                      list.main_detail.cus_proof_id != null
                    "
                    class="d-flex w-100 py-2"
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      {{
                        list.main_detail.cus_proof_id == 1
                          ? "Passport ID"
                          : list.main_detail.cus_proof_id == 2
                          ? "Voter ID"
                          : "Driving License ID"
                      }}
                    </div>
                    <div class=" w-50">
                      {{ list.main_detail.cus_proof_no }}
                    </div>
                  </div>
                  <div class="d-flex w-100 py-2">
                    <div class="cus-view-addr w-50 text-muted">
                      Currency Code
                    </div>
                    <div class=" w-50">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.main_detail.cus_currency,
                          "currency_code"
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                      cus_settings_details.cus_credit_limit &&
                      cus_settings_details.cus_credit_limit.enable == 1
                    "
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      Credit Limit
                    </div>
                    <div class=" w-50">
                      {{
                        list.main_detail.credit_limit == "" ||
                        !parseFloat(list.main_detail.credit_limit) > 0
                          ? "No Limits"
                          : getDetails(
                              $AppDetails.currency_details,
                              list.main_detail.cus_currency,
                              "currency_symbol"
                            ) +
                            " " +
                            list.main_detail.credit_limit
                      }}
                    </div>
                  </div>
                  <div
                    v-if="list.main_detail.cus_website != ''"
                    class="d-flex w-100 py-2"
                  >
                    <div class="cus-view-addr w-50 text-muted">Website</div>
                    <div class=" w-50">
                      {{ list.main_detail.cus_website }}
                    </div>
                  </div>
                  <div
                    v-if="
                      list.main_detail.pricing_name &&
                      enablepricelist.is_price_list_enabled == 1
                    "
                    class="d-flex w-100 py-2"
                  >
                    <div class="cus-view-addr w-50 text-muted">Price List</div>
                    <div class=" w-50">
                      {{ list.main_detail.pricing_name }}
                    </div>
                  </div>
                  <template>
                    <div class="d-flex w-100 py-2">
                      <div class="cus-view-addr w-50 text-muted">
                        GST Treatment
                      </div>
                      <div class=" w-50">
                        {{
                          getJsonPresentValue(
                            $AppDetails.gst_type_list,
                            "gst_type_id",
                            list.main_detail.cus_gst_type,
                            "gst_type_name"
                          )
                        }}
                      </div>
                    </div>
                    <div
                      v-if="
                        list.main_detail.cus_gst_no != '' &&
                        list.main_detail.cus_gst_no != null
                      "
                      class="d-flex w-100 py-2"
                    >
                      <div class="cus-view-addr w-50 text-muted">GST No.</div>
                      <div class=" w-50">
                        {{ list.main_detail.cus_gst_no }}
                      </div>
                    </div>
                  </template>
                  <div
                    v-if="
                      list.main_detail.cus_pan_no != '' &&
                      list.main_detail.cus_pan_no != null
                    "
                    class="d-flex w-100 py-2"
                  >
                    <div class="cus-view-addr w-50 text-muted">PAN No.</div>
                    <div class=" w-50">
                      {{ list.main_detail.cus_pan_no }}
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                      list.main_detail.place_of_supply != null ||
                      list.main_detail.place_of_supply != ''
                    "
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      Place of Supply
                    </div>
                    <div class=" w-50">
                      {{
                        getDetails(
                          $AppDetails.state_details,
                          list.main_detail.place_of_supply,
                          "state_name"
                        )
                      }}
                      ({{ list.main_detail.place_of_supply }})
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="list.main_detail.cus_gst_type != 6"
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      Tax Preference
                    </div>
                    <div class=" w-50">
                      {{ list.main_detail.cus_tax_exempt }}
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                      list.main_detail.exemptreason_name != '' ||
                      list.main_detail.exemptreason_name != null
                    "
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      Exempt Reason
                    </div>
                    <div class=" w-50">
                      {{ list.main_detail.exemptreason_name||'-' }}
                    </div>
                  </div>
                  <!-- <div
                    v-if="list.main_detail.cus_notes != ''"
                    class="d-flex w-100 py-2"
                  >
                    <div class="cus-view-addr w-50 text-muted">
                      Customer Notes
                    </div>
                    <div class="cus-view-addr w-50">
                      {{ list.main_detail.cus_notes }}
                    </div>
                  </div> -->
                </div>
              </b-tab>
              <b-tab
                title="Address"
                class="px-pad py-2"
                title-link-class="text-center"
              >
                <div class="w-100">
                  <!--  billing address -->
                  <div
                    v-for="(list, index) in list.customer_addr"
                    :key="list.cus_addr_id"
                  >
                    <div class="py-2">
                      <span class="theme-text-color pb-2">{{
                        list.cus_addr_type == 1
                          ? "Billing Address"
                          : list.cus_addr_type == 2
                          ? "Shipping Address"
                          : "Additional Address"
                      }}</span>
                      <span
                        class="pl-2"
                        v-if="
                          (list.cus_addr_type == 1 && list.is_billing != 0) ||
                          (list.cus_addr_type == 2 && list.is_shipping != 0) ||
                          list.cus_addr_type == 3
                        "
                      >
                        <i
                          v-if="
                            RoutePermission(
                              false,
                              '',
                              'invoice',
                              'customer',
                              'update'
                            )
                          "
                          class="la la-edit la-lg text-link cursor_pointer"
                          @click="
                            (page = 'update'),
                              toggleCustomerAdditionalDetails(index)
                          "
                        ></i>
                        <span
                          class="text-link pl-2"
                          v-if="list.cus_addr_type == 3"
                        >
                          <i
                            class="glyphicon glyphicon-trash cursor_pointer pb-1"
                            @click="
                              handlingapprovingmodal({
                                content:
                                  'Are you sure you want to delete this Additional Address ?',
                                title: 'Delete Address',
                                module: 'customer/deleteaddress',
                                data: JSON.stringify({
                                  cus_addr_id: list.cus_addr_id,
                                }),
                                RoutePlace: '',
                                isRoute: 'false',
                                type: 'addressdelete',
                              })
                            "
                          ></i>
                        </span>
                      </span>
                      <small
                        class="text-link fw-bold cursor_pointer pl-2 btn-link"
                        v-else-if="
                          RoutePermission(false, '', '', 'customer', 'update')
                        "
                        @click="
                          (page = 'create'),
                            toggleCustomerAdditionalDetails(index)
                        "
                        >Add Address</small
                      >
                      <div class="py-2">
                        <span class="cus-view-addr">{{
                          list.cus_addr_line_1
                        }}</span>
                        <span class="cus-view-addr">{{
                          list.cus_addr_line_2
                        }}</span>
                        <span class="cus-view-addr">{{ list.cus_city }}</span>
                        <span class="cus-view-addr"
                          >{{
                            getDetails(
                              $AppDetails.state_details,
                              list.cus_state,
                              "state_name"
                            )
                          }}
                          {{ list.cus_pincode }}</span
                        >
                        <span class="cus-view-addr">{{
                          getDetails(
                            $AppDetails.country_details,
                            list.cus_country,
                            "country_name"
                          )
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      (list.customer_addr[0].is_billing != 0 ||
                        list.customer_addr[1].is_shipping != 0) &&
                      RoutePermission(false, '', '', 'customer', 'update')
                    "
                  >
                    <small
                      class="fw-bold text-link cursor_pointer btn-link"
                      @click="(page = 'create'), toggleCustomerAddressDetails()"
                      >Add Additional Address</small
                    >
                  </div>
                </div>
              </b-tab>
            </b-tabs>
            <div class="border-bottom"></div>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
              v-b-toggle.customer_notes
              
            >
             Customer Notes
            </h6>
            <div class="border-bottom"></div>
            <b-collapse id="customer_notes"  :visible="list.main_detail.cus_notes!=''">
              <div class="w-100 px-pad">
               <div class="py-2" style="word-break: break-word;white-space: pre-wrap;">{{list.main_detail.cus_notes||'-'}}</div>
              </div>
            </b-collapse>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
              v-b-toggle.customer_remarks
              
            >
             Remarks
            </h6>
            <div class="border-bottom"></div>
            <b-collapse id="customer_remarks" :visible="list.main_detail.cus_internal_notes!=''">
              <div class="w-100 px-pad">
               <div class="py-2" style="word-break: break-word;white-space: pre-wrap;">{{list.main_detail.cus_internal_notes||'-'}}</div>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="view-tab-block">
          <b-tabs
            v-model="tab_index"
            class="customer_view_tab no-flex-grow mt-2 border-tab"
          >
            <b-tab
              title="Overview"
              active
              :title-link-class="{
                'd-print-none': true,
                'd-block d-lg-none': true,
              }"
              class="p-0 d-print-none"
            >
              <div
                v-if="
                  list.main_detail.credit_limit != '' &&
                  cus_settings_details.cus_credit_limit &&
                  cus_settings_details.cus_credit_limit.enable == 1 &&
                  parseFloat(list.main_detail.credit_limit) > 0 &&
                  parseFloat(list.unused_credits.due_amount) -
                    parseFloat(list.unused_credits.total_unused_credits || 0) >
                    parseFloat(list.main_detail.credit_limit)
                "
                class="mb-2 px-pad pt-3"
              >
                <span class="fa fa-warning text-warning"></span>
                Credit limit has exceeded by
                {{
                  getDetails(
                    $AppDetails.currency_details,
                    list.main_detail.cus_currency,
                    "currency_symbol"
                  )
                }}
                {{
                  Number(
                    parseFloat(list.unused_credits.due_amount) -
                      parseFloat(
                        list.unused_credits.total_unused_credits || 0
                      ) -
                      parseFloat(list.main_detail.credit_limit)
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </div>

              <div class="py-3">
                <h6
                  class="fw-semi-bold theme-text-color px-pad"
                  style="padding-bottom: 6px"
                >
                  Customer Details
                </h6>
                <div class="border-bottom"></div>
                <b-row class="px-pad pt-2 pb-1">
                  <b-col cols="12" class="text-truncate">{{
                    list.main_detail.cus_display_name
                  }}</b-col>
                </b-row>
                <b-row class="px-pad pb-1">
                  <b-col cols="12">
                    <small class="text-muted">
                      <span style="width: 23px !important">
                        <i class="fa fa-phone mr-2"></i>
                      </span>
                      {{
                        list.main_detail.cus_ph_no_1 ||
                        list.main_detail.cus_ph_no_2 ||
                        ""
                      }}
                    </small>
                  </b-col>
                </b-row>
                <b-row class="px-pad pb-1" v-if="list.main_detail.cus_mail">
                  <b-col cols="12" class="text-truncate">
                    <small class="text-muted">
                      <span style="width: 23px !important">
                        <i class="la la-envelope-o la-lg mr-2"></i>
                      </span>
                      {{ list.main_detail.cus_mail }}
                    </small>
                  </b-col>
                </b-row>

                <div class="border-bottom"></div>
                <h6
                  class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                  style="padding-bottom: 6px"
                  v-b-toggle.contact-details
                >
                  Contact Persons ({{ list.cus_cntct.length }})
                </h6>
                <div class="border-bottom"></div>
                <b-collapse id="contact-details" visible>
                  <div class="w-100 px-pad">
                    <div
                      v-for="(item, index) in list.cus_cntct"
                      :key="index"
                      class="py-2 d-flex"
                    >
                      <div>
                        <i class="la la-user la-lg mr-2 text-muted"></i>
                      </div>
                      <div class="w-100 px-pad">
                        <div class="cus-view-addr">
                          {{ item.cntct_fname + " " + item.cntct_lname }}
                        </div>
                        <div class="cus-view-addr">{{ item.cntct_no }}</div>
                        <div class="cus-view-addr">{{ item.cntct_mail }}</div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
                <template
                  v-if="
                    reporting_tags.filter(
                      (tag) =>
                        list.main_detail[tag.tag_column_name] != '' &&
                        list.main_detail[tag.tag_column_name] != null
                    ).length != 0
                  "
                >
                  <div class="border-bottom"></div>
                  <h6
                    class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                    style="padding-bottom: 6px"
                    v-b-toggle.reporting-details
                  >
                    Reporting Tags
                  </h6>
                  <div class="border-bottom"></div>
                  <b-collapse id="reporting-details" visible>
                    <div class="w-100 px-pad">
                      <div
                        v-for="(tag, index) in reporting_tags"
                        :key="index"
                        v-if="
                          list.main_detail[tag.tag_column_name] != '' &&
                          list.main_detail[tag.tag_column_name] != null &&
                          list.main_detail[tag.tag_column_name] != 0
                        "
                        class="py-2 d-flex w-100"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          {{ tag.tag_name }}
                        </div>
                        <div class="cus-view-addr w-50">
                          {{
                            getJsonPresentValue(
                              tag.tag_options,
                              "value",
                              list.main_detail[tag.tag_column_name],
                              "label"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </template>

                <template
                  v-if="
                    cus_settings_details.custom_field.filter(
                      (custom_field) =>
                        list.main_detail[custom_field.field_name] &&
                        custom_field.status == 1
                    ).length != 0
                  "
                >
                  <div class="border-bottom"></div>
                  <h6
                    class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                    style="padding-bottom: 6px"
                    v-b-toggle.custom-details
                  >
                    Custom Fields
                  </h6>
                  <div class="border-bottom"></div>
                  <b-collapse id="custom-details">
                    <div class="w-100 px-pad">
                      <div
                        v-for="custom_field in cus_settings_details.custom_field"
                        :key="custom_field.id"
                        v-if="
                          list.main_detail[custom_field.field_name] &&
                          custom_field.status == 1
                        "
                        class="py-2 d-flex w-100"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          {{ custom_field.label_name }}
                        </div>
                        <div
                          v-if="custom_field.datatype == 'select'"
                          class="cus-view-addr w-50"
                        >
                          {{
                            getJsonPresentValue(
                              custom_field.options,
                              "value",
                              list.main_detail[custom_field.field_name],
                              "label"
                            )
                          }}
                        </div>
                        <div
                          v-else-if="custom_field.datatype == 'date'"
                          class="cus-view-addr w-50"
                        >
                          {{
                            getDateFormat(
                              list.main_detail[custom_field.field_name]
                            )
                          }}
                        </div>
                        <div
                          v-else-if="custom_field.datatype == 'amount'"
                          class="cus-view-addr w-50"
                        >
                          {{
                            orgCurrencySymbol +
                            " " +
                            list.main_detail[custom_field.field_name]
                          }}
                        </div>
                        <div
                          v-else-if="custom_field.datatype == 'checkbox'"
                          class="cus-view-addr w-50"
                        >
                          {{
                            list.main_detail[custom_field.field_name] == 1
                              ? "True"
                              : "False"
                          }}
                        </div>
                        <div v-else class="cus-view-addr w-50">
                          {{ list.main_detail[custom_field.field_name] }}
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </template>
                <b-tabs class="customer_view_tab custom-tab" card>
                  <b-tab
                    title="Details"
                    active
                    class="px-pad py-2"
                    title-link-class="text-center"
                  >
                    <div class="w-100">
                      <div class="d-flex w-100 py-2" >
                  <div class="cus-view-addr w-50 text-muted">Customer ID</div>
                  <div class=" w-50">{{ list.main_detail.cus_legacy_id||'-' }}</div>
                </div>
                  <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Customer Type</div>
                  <div class=" w-50">{{ list.main_detail.cus_type==1?'Person':'Organization' }}</div>
                </div>
                  <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Payment Terms</div>
                  <div class=" w-50">{{ list.main_detail.term_name }}</div>
                </div>
                      <div
                        v-if="
                          list.main_detail.cus_proof_id &&
                          list.main_detail.cus_proof_id != null
                        "
                        class="d-flex w-100 py-2"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          {{
                            list.main_detail.cus_proof_id == 1
                              ? "Passport ID"
                              : list.main_detail.cus_proof_id == 2
                              ? "Voter ID"
                              : "Driving License ID"
                          }}
                        </div>
                        <div class=" w-50">
                          {{ list.main_detail.cus_proof_no }}
                        </div>
                      </div>
                      <div class="d-flex w-100 py-2">
                        <div class="cus-view-addr w-50 text-muted">
                          Currency Code
                        </div>
                        <div class=" w-50">
                          {{
                            getDetails(
                              $AppDetails.currency_details,
                              list.main_detail.cus_currency,
                              "currency_code"
                            )
                          }}
                        </div>
                      </div>
                      <div
                        class="d-flex w-100 py-2"
                        v-if="
                          cus_settings_details.cus_credit_limit &&
                          cus_settings_details.cus_credit_limit.enable == 1
                        "
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Credit Limit
                        </div>
                        <div class=" w-50">
                          {{
                            list.main_detail.credit_limit == "" ||
                            !parseFloat(list.main_detail.credit_limit) > 0
                              ? "No Limits"
                              : getDetails(
                                  $AppDetails.currency_details,
                                  list.main_detail.cus_currency,
                                  "currency_symbol"
                                ) +
                                " " +
                                list.main_detail.credit_limit
                          }}
                        </div>
                      </div>
                      <div
                        v-if="list.main_detail.cus_website != ''"
                        class="d-flex w-100 py-2"
                      >
                        <div class="cus-view-addr w-50 text-muted">Website</div>
                        <div class=" w-50">
                          {{ list.main_detail.cus_website }}
                        </div>
                      </div>
                      <div
                        v-if="
                          list.main_detail.pricing_name &&
                          enablepricelist.is_price_list_enabled == 1
                        "
                        class="d-flex w-100 py-2"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Price List
                        </div>
                        <div class=" w-50">
                          {{ list.main_detail.pricing_name }}
                        </div>
                      </div>
                      <template>
                        <div class="d-flex w-100 py-2">
                          <div class="cus-view-addr w-50 text-muted">
                            GST Treatment
                          </div>
                          <div class=" w-50">
                            {{
                              getJsonPresentValue(
                                $AppDetails.gst_type_list,
                                "gst_type_id",
                                list.main_detail.cus_gst_type,
                                "gst_type_name"
                              )
                            }}
                          </div>
                        </div>
                        <div
                          v-if="
                            list.main_detail.cus_gst_no != '' &&
                            list.main_detail.cus_gst_no != null
                          "
                          class="d-flex w-100 py-2"
                        >
                          <div class="cus-view-addr w-50 text-muted">
                            GST No.
                          </div>
                          <div class=" w-50">
                            {{ list.main_detail.cus_gst_no }}
                          </div>
                        </div>
                      </template>
                      <div
                        v-if="
                          list.main_detail.cus_pan_no != '' &&
                          list.main_detail.cus_pan_no != null
                        "
                        class="d-flex w-100 py-2"
                      >
                        <div class="cus-view-addr w-50 text-muted">PAN No.</div>
                        <div class=" w-50">
                          {{ list.main_detail.cus_pan_no }}
                        </div>
                      </div>
                      <div
                        class="d-flex w-100 py-2"
                        v-if="
                          list.main_detail.place_of_supply != null ||
                          list.main_detail.place_of_supply != ''
                        "
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Place of Supply
                        </div>
                        <div class=" w-50">
                          {{
                            getDetails(
                              $AppDetails.state_details,
                              list.main_detail.place_of_supply,
                              "state_name"
                            )
                          }}
                          ({{ list.main_detail.place_of_supply }})
                        </div>
                      </div>
                      <div
                        class="d-flex w-100 py-2"
                        v-if="list.main_detail.cus_gst_type != 6"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Tax Preference
                        </div>
                        <div class=" w-50">
                          {{ list.main_detail.cus_tax_exempt }}
                        </div>
                      </div>
                      <div
                        class="d-flex w-100 py-2"
                        v-if="
                          list.main_detail.exemptreason_name != '' ||
                          list.main_detail.exemptreason_name != null
                        "
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Exempt Reason
                        </div>
                        <div class=" w-50">
                          {{ list.main_detail.exemptreason_name }}
                        </div>
                      </div>
                      <!-- <div
                        v-if="list.main_detail.cus_notes != ''"
                        class="d-flex w-100 py-2"
                      >
                        <div class="cus-view-addr w-50 text-muted">
                          Customer Notes
                        </div>
                        <div class="cus-view-addr w-50">
                          {{ list.main_detail.cus_notes }}
                        </div>
                      </div> -->
                    </div>
                  </b-tab>
                  <b-tab
                    title="Address"
                    class="px-pad py-2"
                    title-link-class="text-center"
                  >
                    <div class="w-100">
                      <!--  billing address -->
                      <div
                        v-for="(list, index) in list.customer_addr"
                        :key="list.cus_addr_id"
                      >
                        <div class="py-2">
                          <span class="theme-text-color pb-2">{{
                            list.cus_addr_type == 1
                              ? "Billing Address"
                              : list.cus_addr_type == 2
                              ? "Shipping Address"
                              : "Additional Address"
                          }}</span>
                          <span
                            class="pl-2"
                            v-if="
                              (list.cus_addr_type == 1 &&
                                list.is_billing != 0) ||
                              (list.cus_addr_type == 2 &&
                                list.is_shipping != 0) ||
                              list.cus_addr_type == 3
                            "
                          >
                            <i
                              v-if="
                                RoutePermission(
                                  false,
                                  '',
                                  'invoice',
                                  'customer',
                                  'update'
                                )
                              "
                              class="la la-edit la-lg text-link cursor_pointer"
                              @click="
                                (page = 'update'),
                                  toggleCustomerAdditionalDetails(index)
                              "
                            ></i>
                            <span
                              class="text-link pl-2"
                              v-if="list.cus_addr_type == 3"
                            >
                              <i
                                class="glyphicon glyphicon-trash cursor_pointer pb-1"
                                @click="
                                  handlingapprovingmodal({
                                    content:
                                      'Are you sure you want to delete this Additional Address ?',
                                    title: 'Delete Address',
                                    module: 'customer/deleteaddress',
                                    data: JSON.stringify({
                                      cus_addr_id: list.cus_addr_id,
                                    }),
                                    RoutePlace: '',
                                    isRoute: 'false',
                                    type: 'addressdelete',
                                  })
                                "
                              ></i>
                            </span>
                          </span>
                          <small
                            class="text-link fw-bold cursor_pointer pl-2 btn-link"
                            v-else
                            @click="
                              (page = 'create'),
                                toggleCustomerAdditionalDetails(index)
                            "
                            >Add Address</small
                          >
                          <div class="py-2">
                            <span class="cus-view-addr">{{
                              list.cus_addr_line_1
                            }}</span>
                            <span class="cus-view-addr">{{
                              list.cus_addr_line_2
                            }}</span>
                            <span class="cus-view-addr">{{
                              list.cus_city
                            }}</span>
                            <span class="cus-view-addr"
                              >{{
                                getDetails(
                                  $AppDetails.state_details,
                                  list.cus_state,
                                  "state_name"
                                )
                              }}
                              {{ list.cus_pincode }}</span
                            >
                            <span class="cus-view-addr">{{
                              getDetails(
                                $AppDetails.country_details,
                                list.cus_country,
                                "country_name"
                              )
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          list.customer_addr[0].is_billing != 0 ||
                          list.customer_addr[1].is_shipping != 0
                        "
                      >
                        <small
                          class="fw-bold text-link cursor_pointer btn-link"
                          @click="
                            (page = 'create'), toggleCustomerAddressDetails()
                          "
                          >Add Additional Address</small
                        >
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
                 <div class="border-bottom"></div>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
              v-b-toggle.customer_notes
              
            >
             Customer Notes
            </h6>
            <div class="border-bottom"></div>
            <b-collapse id="customer_notes"  :visible="list.main_detail.cus_notes!=''">
              <div class="w-100 px-pad">
               <div class="py-2" style="word-break: break-word;white-space: pre-wrap;">{{list.main_detail.cus_notes||'-'}}</div>
              </div>
            </b-collapse>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
              v-b-toggle.customer_remarks
              
            >
             Remarks
            </h6>
            <div class="border-bottom"></div>
            <b-collapse id="customer_remarks" :visible="list.main_detail.cus_internal_notes!=''">
              <div class="w-100 px-pad">
               <div class="py-2" style="word-break: break-word;white-space: pre-wrap;">{{list.main_detail.cus_internal_notes||'-'}}</div>
              </div>
            </b-collapse>
              </div>
            </b-tab>
            <b-tab
              title="Transaction"
              active
              :title-link-class="{ 'd-print-none': true }"
              class="p-0 d-print-none"
            >
              <div
                v-if="
                  list.main_detail.credit_limit != '' &&
                  cus_settings_details.cus_credit_limit &&
                  cus_settings_details.cus_credit_limit.enable == 1 &&
                  parseFloat(list.main_detail.credit_limit) > 0 &&
                  parseFloat(list.unused_credits.due_amount) -
                    parseFloat(list.unused_credits.total_unused_credits || 0) >
                    parseFloat(list.main_detail.credit_limit)
                "
                class="mb-2 px-pad pt-3"
              >
                <span class="fa fa-warning text-warning"></span>
                Credit limit has exceeded by
                {{
                  getDetails(
                    $AppDetails.currency_details,
                    list.main_detail.cus_currency,
                    "currency_symbol"
                  )
                }}
                {{
                  Number(
                    parseFloat(list.unused_credits.due_amount) -
                      parseFloat(
                        list.unused_credits.total_unused_credits || 0
                      ) -
                      parseFloat(list.main_detail.credit_limit)
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </div>
              <div class="mb-2 px-pad pt-3">
                <small>
                  {{
                    list.unused_credits.due_amount == 0 ||
                    !list.unused_credits.due_amount
                      ? "Enter Opening Balance"
                      : "Inclusive of Outstanding Opening Balance amount"
                  }}
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      list.main_detail.cus_currency,
                      "currency_symbol"
                    )
                  }}
                  {{
                    parseFloat(
                      list.unused_credits.due_amount || 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                  <span
                    v-if="
                      RoutePermission(false, '', '', 'customer', 'update') &&
                      RoutePermission(
                        false,
                        '',
                        '',
                        'settings',
                        'openingbalance'
                      )
                    "
                    v-b-modal.update_opening_bal
                    class="text-primary la la-edit la-lg cursor_pointer"
                  ></span>
                </small>
              </div>
              <template
                v-if="
                  !RoutePermission(false, '', '', 'amccontract', 'index') &&
                  !RoutePermission(false, '', '', 'invoice', 'index') &&
                  !RoutePermission(false, '', '', 'credit', 'index') &&
                  !RoutePermission(
                    false,
                    '',
                    '',
                    'paymentsreceived',
                    'index'
                  ) &&
                  !RoutePermission(false, '', '', 'quotation', 'index') &&
                  !RoutePermission(false, '', '', 'recurringinvoice', 'index')
                "
              >
                <p class="p-4 px-pad text-muted">
                  You do not have permission to perform view transcations.
                  Please contact your Administrator.
                </p>
              </template>
              <div role="tablist" class="py-3 px-pad">
                <!--  amc list -->
                <template
                  v-if="RoutePermission(false, '', '', 'amccontract', 'index')"
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="amc_table"
                      @click="
                        getList('fetchcustomeramcview', 1, 10, 'amcCollapse')
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !amcCollapse,
                          'fa fa-caret-down': amcCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >AMC CONTRACT
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(true, 'AmcContractCreate', '', '', '')
                        "
                        @click="
                          goTransaction(
                            'AmcContractCreate',
                            'AmcContract',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="amc_table"
                      v-model="amcCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>AMC</th>
                                <th>Ref</th>
                                <th>Start Date</th>
                                <th>
                                  <span v-b-tooltip.title="'Expiry Date'"
                                    >Exp Date</span
                                  >
                                </th>
                                <th>Avl Qty</th>
                                <th class="text-right">Amount</th>
                                <th class="text-right">Status</th>
                              </tr>
                            </thead>

                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof amc_list.amc_list == 'undefined' ||
                                  amc_list == '' ||
                                  amc_list.amc_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in amc_list.amc_list"
                                  :key="item.amc_hdr_id"
                                >
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'amccontract',
                                        'amccontract',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'AmcContractView',
                                        params: { id: item.amc_hdr_id },
                                      }"
                                      >{{ item.amc_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.amc_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td>{{ getDateFormat(item.date) }}</td>
                                  <td>
                                    {{ getDateFormat(item.amc_end_date) }}
                                  </td>
                                  <td>{{ item.total_avl_qty }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Amount).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>

                                  <td class="text-right">
                                    {{ item.amc_status_name }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof amc_list.amc_list != 'undefined' &&
                            amc_list.amc_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(amc_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomeramcview',
                                  parseInt(amc_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{ (amc_list.page - 1) * amc_list.show + 1 || 0 }}
                              to
                              {{
                                (amc_list.page - 1) * amc_list.show +
                                amc_list.amc_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(amc_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomeramcview',
                                  parseInt(amc_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('amc')"
                        >
                          Total Count :
                          {{ total_amc_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <hr />
                </template>
                <!--  invoice list -->
                <template
                  v-if="RoutePermission(false, '', '', 'invoice', 'index')"
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="invoice_table"
                      @click="
                        getList(
                          'fetchcustomerinvoiceview',
                          1,
                          10,
                          'invoiceCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !invoiceCollapse,
                          'fa fa-caret-down': invoiceCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >INVOICE
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(false, '', '', 'invoice', 'create')
                        "
                        @click="
                          goTransaction(
                            'InvoiceCreate',
                            'Invoice',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="invoice_table"
                      v-model="invoiceCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Invoice</th>
                                <th>Ref</th>
                                <th class="text-right">Total</th>
                                <th class="text-right">Balance</th>
                                <th class="text-right">Status</th>
                              </tr>
                            </thead>

                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof invoice_list.invoice_list ==
                                    'undefined' ||
                                  invoice_list == '' ||
                                  invoice_list.invoice_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in invoice_list.invoice_list"
                                  :key="item.inv_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.date) }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'invoice',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'InvoiceView',
                                        params: { id: item.inv_hdr_id },
                                      }"
                                      >{{ item.inv_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.inv_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Amount).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(
                                        item.Balance_Due
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.inv_status }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof invoice_list.invoice_list != 'undefined' &&
                            invoice_list.invoice_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(invoice_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerinvoiceview',
                                  parseInt(invoice_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (invoice_list.page - 1) * invoice_list.show +
                                  1 || 0
                              }}
                              to
                              {{
                                (invoice_list.page - 1) * invoice_list.show +
                                invoice_list.invoice_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(invoice_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerinvoiceview',
                                  parseInt(invoice_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('invoice')"
                        >
                          Total Count :
                          {{ total_invoice_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <!--  payment list -->
                  <hr />
                </template>
                <template
                  v-if="
                    RoutePermission(false, '', '', 'paymentsreceived', 'index')
                  "
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="payment_table"
                      @click="
                        getList(
                          'fetchcustomerpaymentview',
                          1,
                          10,
                          'paymentCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !paymentCollapse,
                          'fa fa-caret-down': paymentCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >CUSTOMER PAYMENT
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(
                            false,
                            '',
                            '',
                            'paymentsreceived',
                            'create'
                          )
                        "
                        @click="
                          goTransaction(
                            'PaymentCreate',
                            'Payment',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="payment_table"
                      v-model="paymentCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->

                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Payment</th>
                                <th>Ref</th>
                                <th>Mode</th>
                                <th class="text-right">Received</th>
                                <th class="text-right">Unused</th>
                              </tr>
                            </thead>

                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof payment_list.Payment_list ==
                                    'undefined' ||
                                  payment_list == '' ||
                                  payment_list.Payment_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in payment_list.Payment_list"
                                  :key="item.pymnt_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.Date) }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'paymentsreceived',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name:
                                          item.pymnt_type == 4
                                            ? 'CustomerAdvanceView'
                                            : 'PaymentView',
                                        params: { id: item.pymnt_hdr_id },
                                      }"
                                      >{{ item.pymnt_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.pymnt_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td>{{ item.payment_mode }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(
                                        item.Amount_Received
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(
                                        item.Unused_Amount
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof payment_list.Payment_list != 'undefined' &&
                            payment_list.Payment_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(payment_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerpaymentview',
                                  parseInt(payment_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (payment_list.page - 1) * payment_list.show +
                                  1 || 0
                              }}
                              to
                              {{
                                (payment_list.page - 1) * payment_list.show +
                                payment_list.Payment_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(payment_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerpaymentview',
                                  parseInt(payment_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('payment')"
                        >
                          Total Count :
                          {{ total_payment_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <!--  retainer list -->
                  <hr />
                </template>
                <template
                  v-if="
                    RoutePermission(false, '', '', 'paymentsreceived', 'index')
                  "
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="retainer_table"
                      @click="
                        getList(
                          'fetchcustomerretainerview',
                          1,
                          10,
                          'retainerCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !retainerCollapse,
                          'fa fa-caret-down': retainerCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >CUSTOMER DEPOSIT
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(
                            true,
                            'RetainerInvoiceCreate',
                            '',
                            '',
                            ''
                          )
                        "
                        @click="
                          goTransaction(
                            'RetainerInvoiceCreate',
                            'RetainerInvoice',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="retainer_table"
                      v-model="retainerCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Deposit</th>
                                <th>Ref</th>
                                <th class="text-right">Total</th>
                                <th class="text-right">Balance</th>
                                <th class="text-right">Status</th>
                              </tr>
                            </thead>

                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof retainer_list.Retainer_list ==
                                    'undefined' ||
                                  retainer_list == '' ||
                                  retainer_list.Retainer_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in retainer_list.Retainer_list"
                                  :key="item.retainer_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.Date) }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'paymentsreceived',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'RetainerInvoiceView',
                                        params: { id: item.retainer_hdr_id },
                                      }"
                                      >{{ item.retainer_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.retainer_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Amount).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(
                                        item.Balance_due
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.retainer_status }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof retainer_list.Retainer_list != 'undefined' &&
                            retainer_list.Retainer_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(retainer_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerretainerview',
                                  parseInt(retainer_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (retainer_list.page - 1) * retainer_list.show +
                                  1 || 0
                              }}
                              to
                              {{
                                (retainer_list.page - 1) * retainer_list.show +
                                retainer_list.Retainer_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(retainer_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerretainerview',
                                  parseInt(retainer_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('retainer')"
                        >
                          Total Count :
                          {{ total_retainer_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <!-- quotation -->
                  <hr />
                </template>
                <template
                  v-if="RoutePermission(false, '', '', 'quotation', 'index')"
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="quotation_table"
                      @click="
                        getList(
                          'fetchcustomerquotationview',
                          1,
                          10,
                          'quotationCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !quotationCollapse,
                          'fa fa-caret-down': quotationCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >QUOTATION
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(
                            false,
                            '',
                            'invoice',
                            'quotation',
                            'create'
                          )
                        "
                        @click="
                          goTransaction(
                            'SalesCreate',
                            'Sales',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="quotation_table"
                      v-model="quotationCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Quotation</th>
                                <th>Ref</th>
                                <th class="text-right">Total</th>
                                <th class="text-right">Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof quotation_list.Quotation_list ==
                                    'undefined' ||
                                  quotation_list == '' ||
                                  quotation_list.Quotation_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="5" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in quotation_list.Quotation_list"
                                  :key="item.sal_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.Date) }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'quotation',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'SalesView',
                                        params: { id: item.sal_hdr_id },
                                      }"
                                      >{{ item.quot_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.quot_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Amount).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.quot_status }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof quotation_list.Quotation_list !=
                              'undefined' &&
                            quotation_list.Quotation_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(quotation_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerquotationview',
                                  parseInt(quotation_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (quotation_list.page - 1) *
                                  quotation_list.show +
                                  1 || 0
                              }}
                              to
                              {{
                                (quotation_list.page - 1) *
                                  quotation_list.show +
                                quotation_list.Quotation_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(quotation_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerquotationview',
                                  parseInt(quotation_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('quotation')"
                        >
                          Total Count :
                          {{ total_quotation_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <hr />
                </template>
                <template
                  v-if="
                    RoutePermission(false, '', '', 'recurringinvoice', 'index')
                  "
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="recurring_table"
                      @click="
                        getList(
                          'fetchcustomerrecurringview',
                          1,
                          10,
                          'recurringCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !recurringCollapse,
                          'fa fa-caret-down': recurringCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span>
                      RECURRING INVOICE
                      <b-badge
                        variant="primary"
                        class="float-right btn-link"
                        v-if="
                          list.main_detail.cus_status == 1 &&
                          RoutePermission(
                            false,
                            '',
                            'invoice',
                            'recurringinvoice',
                            'create'
                          )
                        "
                        @click="
                          goTransaction(
                            'RecurringInvoiceCreate',
                            'RecurringInvoice',
                            list.main_detail.cus_id
                          )
                        "
                      >
                        <i class="la la-plus"></i> New
                      </b-badge>
                    </div>

                    <b-collapse
                      id="recurring_table"
                      v-model="recurringCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Profile</th>
                                <th>Recurring</th>
                                <th>Frequency</th>
                                <th>Last Inv Date</th>
                                <th>Next Inv Date</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->

                            <tbody>
                              <template
                                v-if="
                                  typeof recurring_list.Recurring_list ==
                                    'undefined' ||
                                  recurring_list == '' ||
                                  recurring_list.Recurring_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in recurring_list.Recurring_list"
                                  :key="item.rec_inv_hdr_id"
                                >
                                  <td>{{ item.profile_name }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'recurringinvoice',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'RecurringInvoiceView',
                                        params: { id: item.rec_inv_hdr_id },
                                      }"
                                      >{{ item.rec_inv_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.rec_inv_no }}</td>
                                  <td>{{ item.frequency }}</td>
                                  <td>
                                    {{ getDateFormat(item.last_inv_date) }}
                                  </td>
                                  <td>
                                    {{ getDateFormat(item.next_inv_date) }}
                                  </td>
                                  <td>{{ item.recurring_status }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof recurring_list.Recurring_list !=
                              'undefined' &&
                            recurring_list.Recurring_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(recurring_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerrecurringview',
                                  parseInt(recurring_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (recurring_list.page - 1) *
                                  recurring_list.show +
                                  1 || 0
                              }}
                              to
                              {{
                                (recurring_list.page - 1) *
                                  recurring_list.show +
                                recurring_list.Recurring_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(recurring_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomerrecurringview',
                                  parseInt(recurring_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('recurring')"
                        >
                          Total Count :
                          {{ total_recurring_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <!-- Credit -->
                  <hr />
                </template>
                <template
                  v-if="RoutePermission(false, '', '', 'credit', 'index')"
                >
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="credit_table"
                      @click="
                        getList(
                          'fetchcustomercreditview',
                          1,
                          10,
                          'creditCollapse'
                        )
                      "
                    >
                      <span
                        :class="{
                          'fa fa-caret-right': !creditCollapse,
                          'fa fa-caret-down': creditCollapse,
                          'pb-1 pr-2': true,
                        }"
                      ></span
                      >CREDIT DETAILS
                    </div>

                    <b-collapse
                      id="credit_table"
                      v-model="creditCollapse"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Credit</th>
                                <th>Ref</th>
                                <th class="text-right">Balance</th>
                                <th class="text-right">Amount</th>
                                <th class="text-right">Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                                  typeof credit_list.Credit_list ==
                                    'undefined' ||
                                  credit_list == '' ||
                                  credit_list.Credit_list.length == 0
                                "
                              >
                                <tr>
                                  <td colspan="6" class="text-center">
                                    No data to display
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in credit_list.Credit_list"
                                  :key="item.crdt_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.Date) }}</td>
                                  <td
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'credit',
                                        'index'
                                      )
                                    "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                        name: 'CreditView',
                                        params: { id: item.crdt_hdr_id },
                                      }"
                                      >{{ item.crdt_no }}</router-link
                                    >
                                  </td>
                                  <td v-else>{{ item.crdt_no }}</td>
                                  <td>{{ item.ref_no }}</td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Balance).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      orgCurrencySymbol +
                                      " " +
                                      parseFloat(item.Amount).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.credit_status }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                            typeof credit_list.Credit_list != 'undefined' &&
                            credit_list.Credit_list.length > 0
                          "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                                parseInt(credit_list.page) == 1
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomercreditview',
                                  parseInt(credit_list.page) - 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                                (credit_list.page - 1) * credit_list.show + 1 ||
                                0
                              }}
                              to
                              {{
                                (credit_list.page - 1) * credit_list.show +
                                credit_list.Credit_list.length
                              }}
                            </li>
                            <li
                              :style="
                                parseInt(credit_list.next_record) == 0
                                  ? 'pointer-events:none;opacity : 0.8'
                                  : ''
                              "
                              class="page-item"
                              @click="
                                getPaginationList(
                                  'fetchcustomercreditview',
                                  parseInt(credit_list.page) + 1,
                                  10
                                )
                              "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>

                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('credit')"
                        >
                          Total Count :
                          {{ total_credit_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                </template>
              </div>
            </b-tab>
            <b-tab
              v-if="
                RoutePermission(false, '', 'invoice', 'customer', 'statement')
              "
              title="Statement"
              :title-link-class="{ 'd-print-none': true }"
              class="p-0"
              @click="$refs.customerstatement.createdData()"
            >
              <CustomerStatement
                v-if="cus_statement"
                class="py-4 custom-md-width px-pad"
                ref="customerstatement"
              ></CustomerStatement>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <!--  Amount Details -->

      <OpeningBalanceModal
        :id="id"
        :module="'customer'"
        :opening_balance="list.main_detail.export_opening_balance"
        :due_amount="list.unused_credits.due_amount"
        :currency="list.main_detail.cus_currency"
        :unit_currency="list.main_detail.unit_currency"
        @updated="recallDetails()"
      ></OpeningBalanceModal>
      <AdditionalAddress
        :page="this.page"
        :field="cusaddress"
        addresstype="view"
        :copyadd="this.copyaddress"
        :is_used="cus_txn"
      ></AdditionalAddress>
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
        v-on:setSuccessHandlingModal="getSuccessHandlingModal"
      />
      <CreditListAvailable
        :field="creditDetails"
        :title="list.main_detail.cus_display_name + ' - Credits Detail '"
        :currency="
          getDetails(
            $AppDetails.currency_details,
            list.main_detail.cus_currency,
            'currency_symbol'
          )
        "
      ></CreditListAvailable>
      <FlyOver :show_full_layout="show_full_layout">
        <template slot="page-content" v-if="show_full_layout">
          <h5 class="mb-4 fw-semi-bold text-left">
            Customer Statement Templates
            <span class="float-right pr-2">
              <i
                class="la la-close cursor_pointer fw-semi-bold pr-1"
                @click="show_full_layout = false"
              ></i>
            </span>
          </h5>
          <CustomerStatementPrint
            :path="$route.fullPath"
            :show_full_layout="show_full_layout"
          />
        </template>
      </FlyOver>
      <b-modal
        id="statusPage"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Status"
        @ok="statusChange"
        :ok-disabled="submitted"
      >
        <p>Are you sure you want to {{ statusPage }} the selected customer ?</p>
      </b-modal>
      <LogRecord :message="logrecords"></LogRecord>
    </template>
  </div>
</template>
<script>
import CustomerStatementPrint from "@/pages/Settings/Invoice/Customerprint";
import RecordNotFound from "@/pages/Error/RecordNotFound";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState, mapGetters } from "vuex";
import AdditionalAddress from "@/components/Form/Customer/AdditionalAddress"; // credits available modal\
import { notificationMixin } from "@/mixins/notification";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import CreditListAvailable from "@/components/Modal/Customer/CreditListModal"; // credits available modal\
import store from "@/store/index";
import CustomerStatement from "@/components/Form/Customer/CustomerStatement"; // customer statement
import OpeningBalanceModal from "@/components/Modal/OpeningBalanceModal"; // customer statement
import FlyOver from "@/components/Layout/Flyover";
import LogRecord from "@/components/Modal/ErrorList";

export default {
  props: ["id"],
  mixins: [notificationMixin],
  components: {
    CreditListAvailable,
    CustomerStatement,
    AdditionalAddress,
    OpeningBalanceModal,
    FlyOver,
    CustomerStatementPrint,
    LogRecord,
    RecordNotFound,
  },
  props: ["id"],
  data() {
    return {
      cus_txn: 0,
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      copyaddress: "",
      cusaddress: {
        cus_id: "",
        cus_addr_line_1: "",
        cus_addr_line_2: "",
        cus_state: "",
        cus_city: "",
        cus_country: "",
        cus_pincode: "",
        cus_addr_id: "",
        cus_addr_type: "",
        cus_addr_cat: 1,
      },
      title: "",
      page: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      creditDetails: {},
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      invoiceCollapse: false,
      amcCollapse: false,
      paymentCollapse: false,
      retainerCollapse: false,
      adressCollapse: true,
      quotationCollapse: false,
      creditCollapse: false,
      recurringCollapse: false,
      cus_statement: true,
      show_full_layout: false,
      statusPage: "",
      logrecords: "",
      tab_index: 1,
    };
  },
  methods: {
    goTransaction(createPage, indexPage, id) {
      this.$store
        .dispatch("customer/checkCustomerExist", { id: id })
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              name: createPage,
              query: {
                customer_id: id,
                type: indexPage == "Invoice" ? "invoice" : "",
              },
            });
          } else {
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true,
            });
            this.$router.push({
              name: indexPage,
            });
          }
        });
    },
    statusChange() {
      var data = JSON.stringify({
        name: this.statusPage,
        status: [this.id],
      });
      store.dispatch("customer/custstatus", data).then((response) => {
        this.submitted = false;
        if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
          if (this.message.message.length == 0) {
            this.list.main_detail.cus_status =
              this.statusPage == "active" ? 1 : 0;
          }
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.message,
            type: response.data.type,
            showCloseButton: true,
          });
        }
      });
    },
    async showFullLayout() {
      await store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "customer",
        })
        .then(() => {
          this.show_full_layout = true;
        });
    },
    async recallDetails() {
      this.cus_statement = await false;
      await store
        .dispatch("customer/fetchViewList", parseInt(this.id))
        .then(() => {
          this.cus_statement = true;
        });
    },

    getSuccessHandlingModal() {
      if (this.globalmodaltype == "addressdelete") {
        this.$store.dispatch("customer/fetchViewList", this.$route.params.id);
      }
    },

    //Customer details
    async toggleCustomerAdditionalDetails(index) {
      if (this.page == "update") {
        this.cusaddress = {
          cus_id: this.$route.params.id,
          cus_addr_line_1: this.list.customer_addr[index].cus_addr_line_1,
          cus_addr_line_2: this.list.customer_addr[index].cus_addr_line_2,
          cus_state: this.list.customer_addr[index].cus_state,
          cus_city: this.list.customer_addr[index].cus_city,
          cus_country: this.list.customer_addr[index].cus_country,
          cus_pincode: this.list.customer_addr[index].cus_pincode,
          cus_addr_id: this.list.customer_addr[index].cus_addr_id,
          cus_addr_type: this.list.customer_addr[index].cus_addr_type,
          cus_addr_cat: 1,
        };
      }
      if (this.page == "create") {
        this.cusaddress = {
          cus_id: this.$route.params.id,
          cus_addr_line_1: "",
          cus_addr_line_2: "",
          cus_state: "",
          cus_city: "",
          cus_country: "",
          cus_pincode: "",
          cus_addr_id: this.list.customer_addr[index].cus_addr_id,
          cus_addr_type: this.list.customer_addr[index].cus_addr_type,
          cus_addr_cat: 1,
        };
      }

      if (
        this.cusaddress.cus_addr_type == 2 &&
        this.list.customer_addr[0].is_billing != 0
      ) {
        this.copyaddress = {
          cus_addr_line_1: this.list.customer_addr[0].cus_addr_line_1,
          cus_addr_line_2: this.list.customer_addr[0].cus_addr_line_2,
          cus_state: this.list.customer_addr[0].cus_state,
          cus_city: this.list.customer_addr[0].cus_city,
          cus_country: this.list.customer_addr[0].cus_country,
          cus_pincode: this.list.customer_addr[0].cus_pincode,
        };
      } else {
        this.copyaddress = "";
      }
      await EventBus.$emit("toggleCustomerAdditionalDetails");
    },
    async toggleCustomerAddressDetails() {
      this.cusaddress = {
        cus_id: this.$route.params.id,
        cus_addr_line_1: "",
        cus_addr_line_2: "",
        cus_state: "",
        cus_city: "",
        cus_country: "",
        cus_pincode: "",
        cus_addr_id: "",
        cus_addr_type: 3,
        cus_addr_cat: 1,
      };
      await EventBus.$emit("toggleCustomerAdditionalDetails");
    },
    // call avialbel modal
    callavailablecreditsmodal() {
      this.creditDetails = {
        crdt_total_amount: this.list.unused_credits.total_unused_credits,
      };
      this.$root.$emit("bv::show::modal", "availablecredits");
      EventBus.$emit("creditdetails");
    },
    async getTotalCount(type) {
      await store.dispatch("customer/viewtotalcount", {
        id: this.$route.params.id,
        type: type,
      });
      this[type] = true;
    },
    //  delete whole customer
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },

    async getList(url, page, show, type) {
      if (this[type] == false) {
        const Vpage = page || 1;
        const Vshow = show || 10;
        await store.dispatch("customer/" + url, {
          page: Vpage,
          show: Vshow,
          id: this.$route.params.id,
        });
        this[type] = true;
      } else {
        this[type] = false;
      }
    },
    async getPaginationList(url, page, show) {
      const Vpage = page || 1;
      const Vshow = show || 10;
      await store.dispatch("customer/" + url, {
        page: Vpage,
        show: Vshow,
        id: this.$route.params.id,
      });
    },
    async getTableList(url) {
      await store.dispatch("customer/" + url, {
        page: 1,
        show: 10,
        id: this.$route.params.id,
      });
    },
  },
  async created() {
    this.tab_index = (await this.$route.query.tab_index) || 1;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
    if (this.status_code != 404) {
      document.title = getPageTitle(
        this.list.main_detail.cus_display_name + " | " + this.$route.meta.title
      );
      this.cus_txn = this.list.main_detail.is_used;

      this.getTableList("fetchcustomeramcview").then(() => {
        this.amcCollapse = this.amc_list.amc_list.length > 0;
      });
      this.getTableList("fetchcustomerinvoiceview").then(() => {
        this.invoiceCollapse = this.invoice_list.invoice_list.length > 0;
      });
      this.getTableList("fetchcustomerpaymentview").then(() => {
        this.paymentCollapse = this.payment_list.Payment_list.length > 0;
      });
      this.getTableList("fetchcustomerquotationview").then(() => {
        this.quotationCollapse = this.quotation_list.Quotation_list.length > 0;
      });
      this.getTableList("fetchcustomerretainerview").then(() => {
        this.retainerCollapse = this.retainer_list.Retainer_list.length > 0;
      });
      this.getTableList("fetchcustomerrecurringview").then(() => {
        this.recurringCollapse = this.recurring_list.Recurring_list.length > 0;
      });
      this.getTableList("fetchcustomercreditview").then(() => {
        this.creditCollapse = this.credit_list.Credit_list.length > 0;
      });
    }
  },
  computed: {
    ...mapState({
      list: (state) => state.customer.listView,
      code: (state) => state.customer.code,
      enablepricelist: (state) => state.permission.price_list,
      amc_list: (state) => state.customer.amc_list,
      invoice_list: (state) => state.customer.invoice_list,
      payment_list: (state) => state.customer.payment_list,
      quotation_list: (state) => state.customer.quotation_list,
      salesorder_list: (state) => state.customer.salesorder_list,
      package_list: (state) => state.customer.package_list,
      retainer_list: (state) => state.customer.retainer_list,
      recurring_list: (state) => state.customer.recurring_list,
      credit_list: (state) => state.customer.credit_list,
      total_amc_list: (state) => state.customer.total_amc_list,
      total_invoice_list: (state) => state.customer.total_invoice_list,
      total_payment_list: (state) => state.customer.total_payment_list,
      total_quotation_list: (state) => state.customer.total_quotation_list,
      total_retainer_list: (state) => state.customer.total_retainer_list,
      total_recurring_list: (state) => state.customer.total_recurring_list,
      total_salesorder_list: (state) => state.customer.total_salesorder_list,
      total_credit_list: (state) => state.customer.total_credit_list,
      total_package_list: (state) => state.customer.total_package_list,
      delete: (state) => state.customer.delete,
      message: (state) => state.customer.log_details,
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
      cus_index_history: (state) => state.customer.cus_index_history,
    }),
    ...mapGetters([
      "orgCurrencySymbol",
      "cus_settings_details",
      "reporting_tags",
    ]),
  },
};
</script>
